// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { navigationListStyles } from "@vanmeter/Overrides/Widgets/Basic/NavigationList";
import { fontConfig } from "@vanmeter/XDL/constants";
import { color } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

navigationListStyles.link = {
    typographyProps: {
        ...fontConfig.smallSingleLine,
        weight: fontConfig.weight.bold,
        lineHeight: fontConfig.smallSingleLine.lineHeight,
    },
};

navigationListStyles.splitter = {
    css: css`
        border-top: 1px solid ${color("common.border")};
        ${({ marginBottom }: any) => `margin-bottom: ${marginBottom}px`}
    `,
};
